import { createSlice } from '@reduxjs/toolkit';

const logsSlice = createSlice({
    name: 'logs',
    initialState: {
        activityLogs: { data: null, loading: false, error: null }, // All activity logs
        userActivityLogs: { data: null, loading: false, error: null }, // User-specific activity logs
        auditLogs: { data: null, loading: false, error: null }, // All audit logs
        filteredAuditLogs: { data: null, loading: false, error: null }, // Audit logs filtered by action type
    },
    reducers: {
        // Start actions
        fetchActivityLogsStart: (state) => {
            state.activityLogs.loading = true;
            state.activityLogs.error = null;
        },
        fetchUserActivityLogsStart: (state) => {
            state.userActivityLogs.loading = true;
            state.userActivityLogs.error = null;
        },
        fetchAuditLogsStart: (state) => {
            state.auditLogs.loading = true;
            state.auditLogs.error = null;
        },
        fetchFilteredAuditLogsStart: (state) => {
            state.filteredAuditLogs.loading = true;
            state.filteredAuditLogs.error = null;
        },

        // Success actions
        fetchActivityLogsSuccess: (state, action) => {
            state.activityLogs.loading = false;
            state.activityLogs.data = action.payload;
        },
        fetchUserActivityLogsSuccess: (state, action) => {
            state.userActivityLogs.loading = false;
            state.userActivityLogs.data = action.payload;
        },
        fetchAuditLogsSuccess: (state, action) => {
            state.auditLogs.loading = false;
            state.auditLogs.data = action.payload;
        },
        fetchFilteredAuditLogsSuccess: (state, action) => {
            state.filteredAuditLogs.loading = false;
            state.filteredAuditLogs.data = action.payload;
        },

        // Fail actions
        fetchActivityLogsFail: (state, action) => {
            state.activityLogs.loading = false;
            state.activityLogs.error = action.payload;
        },
        fetchUserActivityLogsFail: (state, action) => {
            state.userActivityLogs.loading = false;
            state.userActivityLogs.error = action.payload;
        },
        fetchAuditLogsFail: (state, action) => {
            state.auditLogs.loading = false;
            state.auditLogs.error = action.payload;
        },
        fetchFilteredAuditLogsFail: (state, action) => {
            state.filteredAuditLogs.loading = false;
            state.filteredAuditLogs.error = action.payload;
        },
    },
});

export const {
    fetchActivityLogsStart,
    fetchActivityLogsSuccess,
    fetchActivityLogsFail,
    fetchUserActivityLogsStart,
    fetchUserActivityLogsSuccess,
    fetchUserActivityLogsFail,
    fetchAuditLogsStart,
    fetchAuditLogsSuccess,
    fetchAuditLogsFail,
    fetchFilteredAuditLogsStart,
    fetchFilteredAuditLogsSuccess,
    fetchFilteredAuditLogsFail,
} = logsSlice.actions;

export default logsSlice.reducer;